import { withCommunityNavigationProps } from 'viewModel/gallery/withCommunityNavigationProps';
import CommunityNavigation from 'components/Community/CommunityNavigation/CommunityNavigation';

export default withCommunityNavigationProps(CommunityNavigation);
